// LIBRERIE/IMPORTS
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassLocation, faUserTie, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

//COMPONENTI
import ServiceCard from "./ServiceCard";

interface ServicesSectionProps {
  agencyName: string;
  showServices2: boolean;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ agencyName, showServices2 }) => {
  const { t } = useTranslation();

  if (!showServices2) return null;

    const services = [
      {
        "title" : t('homePage.servicesSection2.serviceTitle1'),
        "icon" : <FontAwesomeIcon icon={faMagnifyingGlassLocation} />,
        "description" : t('homePage.servicesSection2.description1'),
        "link" : "/chi-siamo",
        "label": t('navigation.aboutUsLinkTitle')
      },
      {
        "title" : t('homePage.servicesSection2.serviceTitle2'),
        "icon" : <FontAwesomeIcon icon={faUserTie} />,
        "description" : t('homePage.servicesSection2.description2'),
        "link" : "/contatti",
        "label": t('navigation.contactUsLinkTitle')
      },
      {
        "title" : t('homePage.servicesSection2.serviceTitle3'),
        "icon" : <FontAwesomeIcon icon={faGlobe} />,
        "description" : t('homePage.servicesSection2.description3'),
        "link" : "/servizi",
        "label": t('navigation.servicesLinkTitle')
      }
    ];

    return (
      <section className="space-ptb bg-green" id="agency-services-promo">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="section-title text-center col-12">
              <h3 className="asH2SubTitle text-white">{agencyName}</h3>
              <p>{t('homePage.servicesSection2.subTitle')}</p>
            </div>
            {services.map((service, index) => (
              <ServiceCard 
                serviceId = {index}
                service = {service}
              />
            ))}
          </div>
        </div>
      </section>
  );
};

export default ServicesSection;